// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true,valid_types=protovalidate_required"
// @generated from file proto/v1/denormalized.proto (package vmspdb.api.proto.v1, syntax proto3)
/* eslint-disable */

// buf:lint:ignore PACKAGE_DIRECTORY_MATCH

import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type {
  ProjectJobType,
  ProjectJobTypeJson,
  ProjectSurveyTaskTypeWithDescription,
  ProjectSurveyTaskTypeWithDescriptionJson,
} from './type_common_pb';
import { file_proto_v1_type_common } from './type_common_pb';

/**
 * Describes the file proto/v1/denormalized.proto.
 */
export const file_proto_v1_denormalized: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Chtwcm90by92MS9kZW5vcm1hbGl6ZWQucHJvdG8SE3Ztc3BkYi5hcGkucHJvdG8udjEiMAoSRGVub3JtYWxpemVkQ2xpZW50EgwKBHV1aWQYASABKAkSDAoEbmFtZRgCIAEoCSIuChBEZW5vcm1hbGl6ZWRVc2VyEgwKBHV1aWQYASABKAkSDAoEbmFtZRgCIAEoCSJFChNEZW5vcm1hbGl6ZWRQcm9qZWN0EgwKBHV1aWQYASABKAkSDAoEbmFtZRgCIAEoCRISCgpqb2JfbnVtYmVyGAMgASgJIp8BChZEZW5vcm1hbGl6ZWRQcm9qZWN0Sm9iEgwKBHV1aWQYASABKAkSNQoEdHlwZRgDIAEoDjIjLnZtc3BkYi5hcGkucHJvdG8udjEuUHJvamVjdEpvYlR5cGVCAhgBEjoKCGpvYl90eXBlGAQgASgLMigudm1zcGRiLmFwaS5wcm90by52MS5EZW5vcm1hbGl6ZWRKb2JUeXBlSgQIAhADIkYKE0Rlbm9ybWFsaXplZEpvYlR5cGUSDAoEdXVpZBgBIAEoCRIMCgRuYW1lGAIgASgJEhMKC2Rlc2NyaXB0aW9uGAMgASgJIn8KFkRlbm9ybWFsaXplZFN1cnZleVRhc2sSDAoEdXVpZBgBIAEoCRINCgVub3RlcxgDIAEoCRJICgV0YXNrcxgEIAMoCzI5LnZtc3BkYi5hcGkucHJvdG8udjEuUHJvamVjdFN1cnZleVRhc2tUeXBlV2l0aERlc2NyaXB0aW9uIkwKHkRlbm9ybWFsaXplZFRpbWVUcmFja2luZ1JlY29yZBITCgtpbl9wcm9ncmVzcxgCIAEoCBIVCg10b3RhbF9zZWNvbmRzGAMgASgNQipaKGdvLnZtc3BkYi5hcHAvcGxhdGZvcm0vaW50ZXJuYWwvcHJvdG8vdjFiBnByb3RvMw',
    [file_proto_v1_type_common],
  );

/**
 * @generated from message vmspdb.api.proto.v1.DenormalizedClient
 */
export type DenormalizedClient =
  Message<'vmspdb.api.proto.v1.DenormalizedClient'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.DenormalizedClient
 */
export type DenormalizedClientJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;
};

export type DenormalizedClientValid = DenormalizedClient;

/**
 * Describes the message vmspdb.api.proto.v1.DenormalizedClient.
 * Use `create(DenormalizedClientSchema)` to create a new message.
 */
export const DenormalizedClientSchema: GenMessage<
  DenormalizedClient,
  { jsonType: DenormalizedClientJson; validType: DenormalizedClientValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_denormalized, 0);

/**
 * @generated from message vmspdb.api.proto.v1.DenormalizedUser
 */
export type DenormalizedUser =
  Message<'vmspdb.api.proto.v1.DenormalizedUser'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.DenormalizedUser
 */
export type DenormalizedUserJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;
};

export type DenormalizedUserValid = DenormalizedUser;

/**
 * Describes the message vmspdb.api.proto.v1.DenormalizedUser.
 * Use `create(DenormalizedUserSchema)` to create a new message.
 */
export const DenormalizedUserSchema: GenMessage<
  DenormalizedUser,
  { jsonType: DenormalizedUserJson; validType: DenormalizedUserValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_denormalized, 1);

/**
 * @generated from message vmspdb.api.proto.v1.DenormalizedProject
 */
export type DenormalizedProject =
  Message<'vmspdb.api.proto.v1.DenormalizedProject'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: string job_number = 3;
     */
    jobNumber: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.DenormalizedProject
 */
export type DenormalizedProjectJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string job_number = 3;
   */
  jobNumber?: string;
};

export type DenormalizedProjectValid = DenormalizedProject;

/**
 * Describes the message vmspdb.api.proto.v1.DenormalizedProject.
 * Use `create(DenormalizedProjectSchema)` to create a new message.
 */
export const DenormalizedProjectSchema: GenMessage<
  DenormalizedProject,
  { jsonType: DenormalizedProjectJson; validType: DenormalizedProjectValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_denormalized, 2);

/**
 * @generated from message vmspdb.api.proto.v1.DenormalizedProjectJob
 */
export type DenormalizedProjectJob =
  Message<'vmspdb.api.proto.v1.DenormalizedProjectJob'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: vmspdb.api.proto.v1.ProjectJobType type = 3 [deprecated = true];
     * @deprecated
     */
    type: ProjectJobType;

    /**
     * @generated from field: vmspdb.api.proto.v1.DenormalizedJobType job_type = 4;
     */
    jobType?: DenormalizedJobType;
  };

/**
 * @generated from message vmspdb.api.proto.v1.DenormalizedProjectJob
 */
export type DenormalizedProjectJobJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: vmspdb.api.proto.v1.ProjectJobType type = 3 [deprecated = true];
   * @deprecated
   */
  type?: ProjectJobTypeJson;

  /**
   * @generated from field: vmspdb.api.proto.v1.DenormalizedJobType job_type = 4;
   */
  jobType?: DenormalizedJobTypeJson;
};

export type DenormalizedProjectJobValid = DenormalizedProjectJob;

/**
 * Describes the message vmspdb.api.proto.v1.DenormalizedProjectJob.
 * Use `create(DenormalizedProjectJobSchema)` to create a new message.
 */
export const DenormalizedProjectJobSchema: GenMessage<
  DenormalizedProjectJob,
  {
    jsonType: DenormalizedProjectJobJson;
    validType: DenormalizedProjectJobValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_denormalized, 3);

/**
 * @generated from message vmspdb.api.proto.v1.DenormalizedJobType
 */
export type DenormalizedJobType =
  Message<'vmspdb.api.proto.v1.DenormalizedJobType'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: string description = 3;
     */
    description: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.DenormalizedJobType
 */
export type DenormalizedJobTypeJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;
};

export type DenormalizedJobTypeValid = DenormalizedJobType;

/**
 * Describes the message vmspdb.api.proto.v1.DenormalizedJobType.
 * Use `create(DenormalizedJobTypeSchema)` to create a new message.
 */
export const DenormalizedJobTypeSchema: GenMessage<
  DenormalizedJobType,
  { jsonType: DenormalizedJobTypeJson; validType: DenormalizedJobTypeValid }
> = /*@__PURE__*/ messageDesc(file_proto_v1_denormalized, 4);

/**
 * @generated from message vmspdb.api.proto.v1.DenormalizedSurveyTask
 */
export type DenormalizedSurveyTask =
  Message<'vmspdb.api.proto.v1.DenormalizedSurveyTask'> & {
    /**
     * @generated from field: string uuid = 1;
     */
    uuid: string;

    /**
     * @generated from field: string notes = 3;
     */
    notes: string;

    /**
     * @generated from field: repeated vmspdb.api.proto.v1.ProjectSurveyTaskTypeWithDescription tasks = 4;
     */
    tasks: ProjectSurveyTaskTypeWithDescription[];
  };

/**
 * @generated from message vmspdb.api.proto.v1.DenormalizedSurveyTask
 */
export type DenormalizedSurveyTaskJson = {
  /**
   * @generated from field: string uuid = 1;
   */
  uuid?: string;

  /**
   * @generated from field: string notes = 3;
   */
  notes?: string;

  /**
   * @generated from field: repeated vmspdb.api.proto.v1.ProjectSurveyTaskTypeWithDescription tasks = 4;
   */
  tasks?: ProjectSurveyTaskTypeWithDescriptionJson[];
};

export type DenormalizedSurveyTaskValid = DenormalizedSurveyTask;

/**
 * Describes the message vmspdb.api.proto.v1.DenormalizedSurveyTask.
 * Use `create(DenormalizedSurveyTaskSchema)` to create a new message.
 */
export const DenormalizedSurveyTaskSchema: GenMessage<
  DenormalizedSurveyTask,
  {
    jsonType: DenormalizedSurveyTaskJson;
    validType: DenormalizedSurveyTaskValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_denormalized, 5);

/**
 * @generated from message vmspdb.api.proto.v1.DenormalizedTimeTrackingRecord
 */
export type DenormalizedTimeTrackingRecord =
  Message<'vmspdb.api.proto.v1.DenormalizedTimeTrackingRecord'> & {
    /**
     * @generated from field: bool in_progress = 2;
     */
    inProgress: boolean;

    /**
     * @generated from field: uint32 total_seconds = 3;
     */
    totalSeconds: number;
  };

/**
 * @generated from message vmspdb.api.proto.v1.DenormalizedTimeTrackingRecord
 */
export type DenormalizedTimeTrackingRecordJson = {
  /**
   * @generated from field: bool in_progress = 2;
   */
  inProgress?: boolean;

  /**
   * @generated from field: uint32 total_seconds = 3;
   */
  totalSeconds?: number;
};

export type DenormalizedTimeTrackingRecordValid =
  DenormalizedTimeTrackingRecord;

/**
 * Describes the message vmspdb.api.proto.v1.DenormalizedTimeTrackingRecord.
 * Use `create(DenormalizedTimeTrackingRecordSchema)` to create a new message.
 */
export const DenormalizedTimeTrackingRecordSchema: GenMessage<
  DenormalizedTimeTrackingRecord,
  {
    jsonType: DenormalizedTimeTrackingRecordJson;
    validType: DenormalizedTimeTrackingRecordValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_denormalized, 6);
